import {m, tx} from '#/browser-framework';


export default {
    view({attrs: {checked}, children}) {
        return m(tx('Ballotbox', {checked}),
            checked && m('span', children));
    },
};
